import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-a28ed514")
const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 0,
  class: "single"
}
const _hoisted_3 = { class: "img-box" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "default-icon",
  src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/%E7%BB%84%20989%402x.png",
  alt: ""
}
const _hoisted_6 = { class: "user-name" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "company" }, "四川生态成品农业开发有限公司", -1)
const _hoisted_8 = { class: "department" }
const _hoisted_9 = {
  key: 1,
  class: "single"
}
const _hoisted_10 = { class: "img-box" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "default-icon",
  src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/%E7%BB%84%20989%402x.png",
  alt: ""
}
const _hoisted_13 = { class: "user-name" }
const _hoisted_14 = { class: "company" }
const _hoisted_15 = { class: "department" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.type == '0')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.initInfo.avatar)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "default-icon",
                  src: _ctx.initInfo.avatar,
                  alt: ""
                }, null, 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("img", _hoisted_5))
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.initInfo.name), 1),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.initInfo.deptName), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_ctx.initInfo.headFileInfo&&_ctx.initInfo.headFileInfo.length != 0)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "default-icon",
                  src: _ctx.initInfo.headFileInfo[0].url,
                  alt: ""
                }, null, 8, _hoisted_11))
              : (_openBlock(), _createElementBlock("img", _hoisted_12))
          ]),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.initInfo.realName), 1),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.initInfo.cooperationName), 1),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.initInfo.address), 1)
        ]))
  ]))
}